/* React */
import React from "react";

/* Components */
import DevOptionsContainer from "src/components/admin-dashboard/settings/dev-options-container/DevOptionsContainer";
import CustomCohorts from "src/components/insights/custom-cohorts/CustomCohorts";

/* Constants */
import { ModalType } from "src/shared/constants/common/Modal";

export const getModalComponent = (modalType: ModalType) => {
  switch (modalType) {
    case ModalType.DEV_OPTIONS:
      return <DevOptionsContainer />;
    case ModalType.CUSTOM_COHORTS:
      return <CustomCohorts />;
    default:
      return undefined;
  }
};
